import { optionEntryId, unitQty } from './optionQty';

const getPrices = (values, product) => {
  const { note, qty, items, ...rest } = values;
  // Option pool that product contains.
  const optionPool = product.optionGroups
    .map((optionGroup) =>
      optionGroup.options.map((option) => ({
        ...option,
        optiongroupdisplayorder: optionGroup.displayorder,
      }))
    )
    .flat();
  // Flat selection list across all groups. Entries are option-id strings
  // (flag-off toggle groups) or {id, qty} objects (allowquantities groups).
  const optionList = Object.keys(rest)
    .map((key) => rest[key])
    .flat();
  // Refined option list with the parameters we want to use. `qty` is the
  // UNIT count per single line item (Global Constraints: client state stores
  // the unit count; the wire boundary multiplies by line qty).
  const refinedOptionList = optionList
    .map((entry) => {
      const foundOption = optionPool.find(
        (option) => option.id === optionEntryId(entry)
      );
      if (foundOption) {
        const { id, name, price, displayorder, optiongroupdisplayorder } =
          foundOption;
        return {
          id,
          name,
          price,
          displayorder,
          optiongroupdisplayorder,
          qty: unitQty(entry),
        };
      } else {
        return null;
      }
    })
    .filter(Boolean);

  // Found item by user's selected main option.
  const foundItem = product.items.find((item) => item.id === items[0]);
  // Calculate Item Total
  const itemTotal = foundItem?.price * qty || 0;
  const feeTotal = foundItem?.itemfee * qty || 0;
  // Calculate Options Total (unit price x unit qty x line qty).
  const optionsTotal = refinedOptionList.reduce((partialSum, option) => {
    const optionTotal = option.price * option.qty * qty || 0;
    return partialSum + optionTotal;
  }, 0);
  // Main Total
  const total = optionsTotal + itemTotal;

  return { feeTotal, total, foundItem, refinedOptionList };
};

export default getPrices;
